// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"418":"38c4f93f","426":"94f9f124","453":"15a9cb34","751":"75cd23ff","774":"e142ce19","796":"29f5fdbd"}[chunkId] + ".chunk.js";
};